import { LayoutList, SlidersHorizontal } from 'lucide-react';
import { ADMIN_GUARD } from '../admin-guard';
import { CONTEXTS, lazyView, type FeatureManifest } from '@/app/registry';
import { adminUsersRoutes } from './routes';

export const adminUsersManifest: FeatureManifest = {
  id: 'admin-users',
  contexts: [CONTEXTS.ADMIN_USERS, CONTEXTS.ADMIN_USER_FORM],

  routes: [{ routes: adminUsersRoutes, errorFallbackLabel: 'Utilisateurs', guard: ADMIN_GUARD }],

  centerView: {
    [CONTEXTS.ADMIN_USERS]: lazyView(
      () => import('../views/AdminUsersListView'),
      'AdminUsersListView',
    ),
    [CONTEXTS.ADMIN_USER_FORM]: lazyView(
      () => import('../views/AdminUserFormView'),
      'AdminUserFormView',
    ),
  },

  panels: {
    left: {
      tabs: {
        [CONTEXTS.ADMIN_USERS]: [
          {
            id: 'admin-nav',
            label: 'Navigation',
            icon: LayoutList,
            view: lazyView(() => import('../views/AdminNavView'), 'AdminNavView'),
          },
          {
            id: 'admin-user-filters',
            label: 'Filtres',
            icon: SlidersHorizontal,
            view: lazyView(() => import('../views/AdminUserFiltersView'), 'AdminUserFiltersView'),
          },
        ],
        [CONTEXTS.ADMIN_USER_FORM]: [
          {
            id: 'admin-nav',
            label: 'Navigation',
            icon: LayoutList,
            view: lazyView(() => import('../views/AdminNavView'), 'AdminNavView'),
          },
        ],
      },
    },
  },

  enabledWhen: {
    roles: ['admin'],
  },

  panelRequirements: {
    [CONTEXTS.ADMIN_USERS]: {
      left: { open: true, defaultActiveTab: 'admin-nav' },
      right: { open: false },
    },
    [CONTEXTS.ADMIN_USER_FORM]: {
      left: { open: true, defaultActiveTab: 'admin-nav' },
      right: { open: false },
    },
  },
};
